<!-- 兑换中心 -->
<template>
    <div class="MMyExchange">
        <Pull :pull="pull" :page="page" @getList="getMyExchange">
            <div class="no_data" v-if="!list.length">
                <div class="bg_box">
                    <img class="bg" :src="require('@/common/images/mmy/no_data_bg.png')" alt="">
                    <img class="no_data_bg" :src="require('@/common/images/mmy/no_data.png')" alt="">
                </div>
                <p class="no_data_text">当前暂无兑换商品</p>
            </div>
            <div class="list" v-else>
                <div class="item" v-for="(item, index) in list" :key="index" @click="goToDetails(item)">
                    <div class="left_img">
                        <img :src="item.kmccoverurl" alt="">
                        <div class="type">{{item.kmctypename}}</div>
                    </div>
                    <div class="right_msg">
                        <p class="goods_name">{{item.kmcname}}</p>
                        <div class="validity">
                            <span v-if="item.kmcexpiretimetype === 1" class="isperpetual">{{item.kmcexpiretime}}</span>
                            <span v-else-if="item.kmcexpiretimetype === 2" class="residue">{{item.kmcexpiretime}}</span>
                            <span v-else class="date">{{item.kmcexpiretime}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Pull>
        <div class="exchange_btn">
            <van-button @click="openExchangeDialog">兑换商品</van-button>
        </div>
        <van-popup v-model="exchangeDialog" :close-on-popstate="true" :close-on-click-overlay="false" class="exchangeDialog">
            <div class="content">
                <p class="title">兑换码</p>
                <div class="input_box">
                    <van-field v-model="codevalue" placeholder="请输入兑换码" />
                </div>
                <div class="btn_box">
                    <div class="cancel" @click="exchangeDialog = false">取消</div>
                    <div class="confirm" @click="validationRedeemcodeInfo">确定</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {getExistingRedeemcodeList, validationRedeemcodeInfo} from 'api/personalCenterApi'
import {mapActions} from 'vuex'
import Pull from 'views/mobile/components/pull/pull'
export default {
    data() {
        return {
            list: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            exchangeDialog: false,
            codevalue: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getMyExchange()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '兑换中心'
    },
    methods: {
        goToDetails(item) {
            // console.log(item)
            location.href = item.detailurlmob
        },
        getMyExchange() {
            this.setLoading(true)
            getExistingRedeemcodeList({
                data: this.page,
                success: res => {
                    this.setLoading(false)
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.list = res.data.content
                    } else {
                        this.list = this.list.concat(res.data.content)
                    }
                    this.page.pageCount = res.data.pageinfo.pageCount
                    this.page.rowCount = res.data.pageinfo.rowCount
                    this.pull.loading = false
                    if (this.page.page >= this.page.pageCount) {
                        this.pull.finished = true
                    } else {
                        this.pull.finished = false
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        validationRedeemcodeInfo() {
            this.setLoading(true)
            validationRedeemcodeInfo({
                data: {codevalue: this.codevalue},
                success: res => {
                    this.setLoading(false)
                    if (!res.data.isvalid) {
                        this.$toast.fail('兑换码无效')
                    } else {
                        this.exchangeDialog = false
                        this.$router.push({
                            name: 'ExchangeMsg',
                            query: {
                                codevalue: this.codevalue
                            }
                        })
                        this.codevalue = ''
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        openExchangeDialog() {
            this.exchangeDialog = true
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Pull
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .MMyExchange {
        .van-list {
            min-height: 100vh;
            padding-bottom: 1.2rem;
            box-sizing: border-box;
        }
        .no_data {
            padding: 2.1rem 0 0;
            .bg_box {
                width: 3.6rem;
                height: 3.08rem;
                margin: auto;
                position: relative;
                .bg {
                    width: 3.6rem;
                    height: 3.08rem;
                }
                .no_data_bg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    width: 2.05rem;
                    height: 2.05rem;
                }
            }
            .no_data_text {
                text-align: center;
                font-size: 0.26rem;
                color: #999999;
            }
        }
        .list {
            .item {
                display: flex;
                padding: 0.32rem;
                background: #fff;
                .left_img {
                    position: relative;
                    margin-right: 0.2rem;
                    img {
                        width: 2.6rem;
                        height: 1.45rem;
                        border-radius: 0.04rem;
                    }
                    .type {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 0.6rem;
                        height: 0.28rem;
                        border-radius: 0.04rem 0 0.04rem 0;
                        background: rgba($color: #000000, $alpha: 0.6);
                        color: #fff;
                        font-size: 0.16rem;
                        text-align: center;
                    }
                }
                .right_msg {
                    .goods_name {
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                        margin-bottom: 0.12rem;
                    }
                    .validity {
                        font-size: 0.28rem;
                        .isperpetual {
                            color: #63CB89;
                        }
                        .residue {
                            color: #EC5E69;
                        }
                        .date {
                            color: #999999;
                        }
                    }
                }
            }
        }
        .exchange_btn {
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 1rem;
            background: #fff;
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            .van-button {
                width: 100%;
                height: 0.7rem;
                line-height: 0.7rem;
                background: #409EFF;
                color: #fff;
                border-radius: 0.38rem;
                padding: 0;
            }
        }
        .exchangeDialog {
            border-radius: 0.15rem;
            .content {
                width: 5rem;
                height: 3.04rem;
                border-radius: 0.15rem;
                .title {
                    text-align: center;
                    padding: 0.4rem 0 0.28rem;
                    font-size: 0.32rem;
                    line-height: 0.45rem;
                }
                .input_box {
                    padding: 0 0.32rem;
                    margin-bottom: 0.32rem;
                    .van-field {
                        width: 100%;
                        height: 0.68rem;
                        background: #F2F2F2;
                        border-radius: 0.06rem;
                        padding: 0.14rem 0.24rem;
                        box-sizing: border-box;
                        .van-field__control {
                            height: 0.4rem;
                        }
                    }
                }
                .btn_box {
                    display: flex;
                    border-top: 0.01rem solid #E5E5E5;
                    height: 0.92rem;
                    div {
                        flex: 1;
                        height: 100%;
                        font-size: 0.32rem;
                        text-align: center;
                        line-height: 0.92rem;
                        color: #666666;
                    }
                    .confirm {
                        border-left: 0.01rem solid #E5E5E5;
                        color: #409EFF;
                    }
                }
            }
        }
    }
</style>